export default {
  handFormControl: {
    type: Boolean,
    default: false,
  },
  rowDataReplaceRequstInfo: {
    type: Object,
    default: null,
  },
  store: {
    type: Object,
    default: null,
  },
  draggable: {
    type: Boolean,
    default: false,
  },
  recordChecked: {
    type: Boolean,
    default: false,
  },
  coercivelyFloatFlag: {
    type: Boolean,
    default: false,
  },
  onSide: {
    type: Boolean,
    default: false,
  },
  onSideBotom: {
    type: Number,
    default: 0,
  },
  errorRowExpression: {
    type: String,
    default: 'row && row.goodsDetail && row.goodsDetail.id',
  },
  conCode: {
    type: String,
  },
  operateCellShow: {
    type: Boolean,
    default: true,
  },
  pageSize: {
    type: Number,
    default: 30,
  },
  turnOnPaging: {
    type: Number,
    default: 50,
  },
  pageSizeOpts: {
    type: Array,
    default: () => [10, 20, 30, 50],
  },
  selection: {
    type: Boolean,
    default: true,
  },
  selectable: {
    // 控制复选框是否可以选择 还是置灰
    type: Function,
    default: () => true,
  },
  title: {
    type: String,
    default: '编辑',
  },
  urlSave: {
    type: String,
    default: null,
  },
  saveParam: {
    type: Object,
    default: () => {},
  },
  urlSaveKey: {
    type: String,
    default: null,
  },
  allEditModalTitle: {
    type: String,
    default: '批量替换',
  },
  sideModalWidth: {
    type: [String, Number],
  },
  choiceSideModalTitle: {
    type: String,
    default: '请选择',
  },
  sideModalBtn: {
    type: String,
    default: '确定',
  },
  menuAddName: {
    type: String,
    default: '增加',
  },

  menuRemoveName: {
    type: String,
    default: '删除',
  },
  menuRemoveIcon: {
    type: String,
    default: 'ivu-icon-icon-pg-delete',
  },
  menuAddShow: {
    type: Boolean,
    default: false,
  },
  editRowMenu: {
    type: Boolean,
    default: true,
  },
  menuDeleteShow: {
    type: Boolean,
    default: true,
  },
  menuRemoveShow: {
    type: Boolean,
    default: false,
  },
  menuInsertShow: {
    type: Boolean,
    default: false,
  },
  menuCopyAddShow: {
    type: Boolean,
    default: false,
  },
  menuSplitShow: {
    type: Boolean,
    default: true,
  },
  menuSplitShowNew: {
    type: Boolean,
    default: false,
  },
  SplitRowParam: {
    type: Object,
    default: () => {
      return {
        url: 'rest/ezscc/goods/selectRegistration',
        method: 'post',
        param: {
          parameters: {},
          pageNo: 1,
          pageSize: 10,
          totalCount: 0,
        },
      }
    },
  },
  //  复制新建的最大个数
  tableMaxLength: {
    type: String,
    default: '',
  },
  changeFun: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  value: {
    type: [Array],
    default: () => [],
  },
  indexLabel: {
    type: String,
    default: '序号',
  },
  localData: {
    type: Array,
    default: null,
  },
  // 表单配置请求URL
  urlItemsDef: {
    type: String,
    default: null,
  },
  setScope: {
    type: String,
    default: 'licenceType',
  },
  //获取列定义请求方式。
  tableColumnDefMethod: {
    type: String,
    default: 'get',
  },
  getRepeatColumnUrl: {
    type: String,
    default: '',
  },
  getRepeatColumnParam: {
    type: Object,
    default: () => {
      return {}
    },
  },
  customColumn: {
    type: Boolean,
    default: false,
  },
  tableColumnCode: {
    type: String,
    default: null,
  },
  tableColDefaultUrl: {
    type: String,
    default: 'rest/main/dict/getTableByCode?tableCode=',
  },
  // 列表定义配置获取URL(配置该项时tableColumnCode和tableColDefaultUrl失效)
  tableColumnDefUrl: {
    type: String,
    default: null,
  },
  // 列表定义配置
  tableColumnDef: {
    type: Object,
  },
  removeAll: {
    type: Boolean,
    default: false,
  },

  menuChooseName: {
    type: String,
    default: '选择',
  },
  chooseUrl: {
    type: String,
    default: '',
  },
  chooseIndex: {
    type: Boolean,
    default: true,
  },
  chooseRequestMethod: {
    type: String,
    default: 'post',
  },
  // 请求参数,json格式或者对象
  chooseRequestParam: {
    type: [String, Object],
    default: null,
  },
  chooseSearchKey: {
    type: String,
    default: 'keyword',
  },
  // 启用校验时候，指定校验的key
  rowDataKey: {
    type: String,
    default: 'items',
  },
  chooseTableColumnDef: {
    type: Array,
    default: () => {
      return [
        {
          prop: 'code',
          label: '编码',
        },
        {
          prop: 'name',
          label: '名称',
        },
      ]
    },
  },
  specialDeleteHandleFlag: {
    type: Boolean,
    default: false,
  },
  addDefaultData: {
    type: Object,
    default: () => {},
  },

  //  自定义操作栏表头名称
  operateCell: {
    type: String,
    default: '操作',
  },
  //  自定义判重字段
  convertArray: {
    type: Array,
    default: () => [],
  },
  //  是否启用自定义判重字段
  isConvertArray: {
    type: Boolean,
    default: false,
  },
  showSortBatch: {
    type: Boolean,
    default: false,
  },
  checkField: {
    type: String,
    default: 'id',
  },
  openValidation: {
    type: Boolean,
    default: true,
  },
  showDoubleRow: {
    type: Boolean,
    default: false,
  },
  doubleRowOptions: {
    type: Array,
    default: () => {
      return [
        {
          value: 'all',
          label: '显示双方商品',
        },
        {
          value: 'our',
          label: '显示己方商品',
        },
        {
          value: 'other',
          label: '显示对方商品',
        },
      ]
    },
  },
  doubleRowDataKey: {
    type: String,
    default: 'item_',
  },
  // 双行显示时，支持配置默认显示
  doubleRowDefOpt: {
    type: String,
    default: 'all',
  },
  useBackCount: {
    type: [String, Boolean],
    default: 'orderBackCountUtil',
  },
  buttonMenuListUrl: {
    type: String,
    default: '',
  },
  buttonMenuListRowUrl: {
    type: String,
    default: null,
  },
  batchChangeForRowsUrl: {
    type: String,
    default: '',
  },
  paddingTop: {
    type: String,
    default: '15',
  },
  batchChangeForRowsFields: {
    type: Array,
    default: () => {
      return []
    },
  },
  routeQuery: {
    type: Object,
    default: () => {
      return {}
    },
  },
  calculateTotal: {
    type: Boolean,
    default: true,
  },
  batchEditShow: {
    type: Boolean,
    default: true,
  },
  batchEditName: {
    type: String,
    default: '批量替换',
  },
  batchEditFromUrl: {
    type: String,
    default: '',
  },
  batchEditModalWidth: {
    //  批量替换的弹窗宽度
    type: String,
    default: '500',
  },
  selectionTableKey: {
    type: String,
    default: '',
  },
  // 是否同步表单数据
  sync: {
    type: Boolean,
    default: false,
  },
  // #8162 发票总金额(含税)、折扣金额(含税)、折扣前总金额(含税)
  begFormData: {
    type: Object,
  },
  showInvoiceDiscountTotal: {
    type: Boolean,
    default: false,
  },
  // 发票总金额(含税)
  invoicePriceTotal: {
    type: [String, Number],
    default: null,
  },
  // 折扣金额(含税)
  invoiceDiscountTotal: {
    type: [String, Number],
    default: null,
  },
  // 折扣前总金额(含税)
  invoicePrice: {
    type: [String, Number],
    default: null,
  },
  // 是否始终显示表格上方按钮组
  alwaysShowTopTableButton: {
    type: Boolean,
    default: false,
  },
  // #8162 End ---------------------------
  showDiscountsTotal: {
    type: Boolean,
    default: false,
  },
  discountsTotalPadLeft: {
    type: String,
    default: '20px',
  },
  discountsDiffTotal: {
    type: [String, Number],
    default: null,
  },
  discountsTotal: {
    type: [String, Number],
    default: null,
  },
  discountEditDisabled: {
    type: Boolean,
    default: false,
  },
  SKUShow: {
    type: Boolean,
    default: false,
  },
  formDef: {
    type: Object,
    default: null,
  },
  tableDataUrl: {
    type: Object,
    default: null,
  },
  saveUrl: {
    type: Object,
    default: () => {
      return {
        method: 'post',
        url: 'rest/main/order/bill/createOrderItemsBySku',
      }
    },
  },
  warehouseKey: {
    type: String,
    default: 'warehouseInclude',
  },
  height: {
    type: [String, Number],
  },
  errorRow: {
    type: Boolean,
    default: true,
  },
  isShowOptionEdit: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    default: '搜索',
  },
  //顶部搜索支持批量配置 [{name: '渲染的组件，默认为panguSelect', key: '查询的行级字段key', props: '组件的props'}]
  topSearchs: Array,
  searchKeys: {
    type: Array,
    default: () => [],
  },
  dispatchComponent: {
    type: String,
    default: null,
  },
  emitComponent: {
    type: Object,
  },
  // 联动的表单项编码，配合监听的事件 registrationSelection.formData.items.disabled
  relactionCodes: {
    type: Array,
    default() {
      return []
    },
  },
  //  是否显示顶部右边input
  isShowTopInupt: {
    type: Boolean,
    default: true,
  },

  //  -----------crudArrayOrder获取顶部下拉------
  priceRange: {
    type: Object,
    default: () => {},
  },
  valueIsObjectOfTopSelect: {
    type: Boolean,
    default: false,
  },

  isShowTopSelect: {
    type: Boolean,
    default: false,
  },
  validateTable: {
    //临时解决方案，flashAddMedicalAndCurdArray组件不开启校验
    type: Boolean,
    default: true,
  },
  //  控制表格顶部选择下拉是否可以操作
  topSelectDisabled: {
    type: Boolean,
    default: false,
  },
  //控制表格顶部选择下拉disabled，主要为了处理form中items不被监听的情况
  topSelectDisabledReq: {
    type: String,
    default: null,
  },
  urlOfTopSelect: {
    type: String,
    default: '',
  },

  remoteOfTopSelect: {
    type: Boolean,
    default: false,
  },
  requestMethodOfTopSelect: {
    type: String,
    default: 'post',
  },
  paramterOfTopSelect: {
    type: Object,
    default: () => {},
  },
  rightTopSelectOptions: {
    //  表格右侧顶部下拉查询组件options 通用下拉过滤查询
    type: Array,
    default: () => [],
  },
  rightTopSelectKeys: {
    //  表格右侧顶部下拉查询组件，查询过滤字段值
    type: Array,
    default: () => [],
  },
  batchEditExtendData: {
    //  是否启用批量替换，选中模式，选中的数据才会被替换
    type: Boolean,
    default: false,
  },
  tableTrMenuItem: {
    //  表格行按钮支持配置实现，
    type: [Object, Array],
    default: () => null,
    //  参数样例
    /* {
                        children: null,
                        icon: null,
                        cssType: null,
                        name:null, //  必传参数
                        showExp: '{{null}}', //  必传参数
                        buttonCode:null //  必传参数 在表格顶部配置的隐藏的按钮的 code
                    } */
  },
  // 是否直接展示删除图标
  isRemoveIcon: {
    type: Boolean,
    default: false,
  },
  enableCellEdit: {
    type: Boolean,
    default: true,
  },
  // 是否显示顶部 复制选中数据
  showTopCopy: {
    type: Boolean,
    default: false,
  },
  // 打开采购价格组下拉
  openForTopSelectOfPurchase: {
    type: Boolean,
    default: false,
  },
  // 开启配置
  // {
  //     valuePath: '',
  //     urlSelect: '',
  //     remote: true,
  //     requestMethod: 'post',
  //     paramters: {},
  //     valueIsObject: true
  //      urlBacthPrice: ''
  // },
  configForTopSelectOfPurchase: {
    type: Object,
    default: null,
  },
  // ---------------------------20200710-lqn-查看冷链信息添加-------------------------------------
  lLRecordInfo: {
    type: Object,
    default: () => {
      return {
        modalTitle: '冷链监控信息',
        tableColDefUrl: '',
        tableDataUrl: '',
        tableDataParam: {},
        tableDataMethod: 'get',
        chartDataUrl: '',
        chartDataParam: {},
        chartDataMethod: 'get',
      }
    },
  },
  menuCheckLLRecord: {
    type: Boolean,
    default: false,
  },
  showTopBtn: {
    // 在编辑页是否显示的顶部按钮
    type: Boolean,
    default: false,
  },
  getDefaultPriceRangeUrl: {
    // 由于灵科接口不一致，该处做兼容处理，当不是采购时的获取默认价格接口设置为可配置
    type: String,
    default: 'rest/main/goods/price/getDefaultPriceRangeForSale',
  },
  //设置分页固定位置
  setPagePosition: {
    type: String,
    default: '',
  },
  //设置分页宽度
  setPageWidth: {
    type: String,
    default: '',
  },
  //是否需要更新表单信息
  isNeedUpDateFormData: {
    type: Boolean,
    default: false,
  },
  //是否将alias设置为null
  isNullShowAlias: {
    type: Boolean,
    default: true,
  },

  //更新表单的url
  upDateFromUrl: {
    type: String,
    default: '',
  },
  //是否进行拆分检查
  isSplitCheck: {
    type: Boolean,
    default: true,
  },
  //获取排序接口数据
  getSortDataUrl: {
    type: String,
    default: null,
  },
  sortParams: {
    type: Object,
    default: null,
  },
  sortMehod: {
    type: String,
    default: 'post',
  },
  //是否排序
  isSort: {
    type: Boolean,
    default: false,
  },
  //   #6935 4.2 点击后复制一条一样的明细出来，新复制的明细直接放在最后即可，相当于是直接新增了一条的效果，不需要插入行的效果。
  // behind: 放在需要复制的一行的后面
  //  final： 放在最后一行
  menuCopyAddPolicy: {
    type: String,
    default: 'behind',
  },
  // 当表格值变化时，需要执行的Action
  tableChangeAction: {
    type: String,
    default: '',
  },
  changeDataAction: {
    type: String,
    default: null,
  },
  /** 需求7209
   * showTopBatchOperation :是否开启顶部的批量操作
   * codesArr：table需要批量操作的字段配置
   */
  showTopBatchOperation: {
    type: Boolean,
    default: false,
  },
  batchOperationCodes: {
    type: Array,
    default: () => {
      return [
        {
          code: 'finance',
          name: '是否开票',
          defaultVal: null,
          // type: 'boolean',
          options: [
            {
              label: '是',
              value: true,
            },
            {
              label: '否',
              value: false,
            },
          ],
        },
        {
          code: 'attrs.valueText.invoiceType',
          name: '开票类型',
          defaultVal: null,
          // type: 'string',
          options: [
            {
              label: '无票',
              value: '无票',
            },
            {
              label: '普票',
              value: '普票',
            },
            {
              label: '专票',
              value: '专票',
            },
          ],
        },
      ]
    },
  },
  // #7231
  isShowTableButtonGroup: { type: Boolean, default: true },
  isHiddenPagination: { type: Boolean, default: false },
  onlyShortcutButton: { type: Boolean, default: false },
  operateCellWidth: { type: Number },
  tbaleExtendData: Object,
  //7998 直调管理
  updteFirstSelectPrice: {
    type: String,
    default: 'rest/main/order/muddle/batchMuddleSalePrice',
  },
  updteSecondSelectPrice: {
    type: String,
    default: 'rest/main/order/muddle/batchMuddlePurchasePrice',
  },
  valueOfTopSelectValuePath: {
    type: String,
    default: 'order.priceRange',
  },
}
